import { Component, Inject } from "@angular/core";
import { NgIf } from "@angular/common";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";

export type ConfiguracionNoticeTone = "confirmation" | "success" | "error";

export interface ConfiguracionNoticeDialogData {
  tone: ConfiguracionNoticeTone;
  eyebrow: string;
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
}

@Component({
  selector: "app-configuracion-notice-dialog",
  standalone: true,
  templateUrl: "./configuracion-notice-dialog.component.html",
  styleUrls: ["./configuracion-notice-dialog.component.css"],
  imports: [NgIf, MatDialogContent, MatDialogActions, MatIcon, MatIconButton],
})
export class ConfiguracionNoticeDialogComponent {
  readonly iconByTone: Record<ConfiguracionNoticeTone, string> = {
    confirmation: "delete_outline",
    success: "check_circle_outline",
    error: "error_outline",
  };

  constructor(
    public readonly dialogRef: MatDialogRef<
      ConfiguracionNoticeDialogComponent,
      boolean
    >,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: ConfiguracionNoticeDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
